import { api } from "./api";

const basePath = "/users";

export const userService = {
  list(params) {
    return api.get(`${basePath}/`, { params });
  },

  getById(id) {
    return api.get(`${basePath}/${id}/`);
  },

  create(payload) {
    return api.post(`${basePath}/`, payload);
  },

  update(id, payload) {
    return api.patch(`${basePath}/${id}/`, payload);
  },

  setPassword(id, payload) {
    return api.post(`${basePath}/${id}/change-password/`, payload);
  },

  updateLastLogin(id, lastLogin) {
    return api.patch(`${basePath}/${id}/`, { last_login: lastLogin });
  },

  remove(id) {
    return api.delete(`${basePath}/${id}/`);
  },
};

export default userService;
